<script lang="ts" setup>
import { reactive, ref } from 'vue';

const isEllipsis = ref(false);

const props = withDefaults(
  defineProps<{
    toolTipValue?: string;
    textAlign?: string;
    isHighlighted?: boolean;
  }>(),
  {
    toolTipValue: '',
    textAlign: 'left',
  }
);

const emits = defineEmits<{
  (e: 'onClick'): void;
}>();

/**
 * テキストにマウスオーバーしたときに、テキストが省略されているかどうかを判定する
 * @param e - イベント
 */
const mouseoverTextLabel = (e: MouseEvent) => {
  const { target } = e;
  if (!(target instanceof HTMLElement)) return;
  isEllipsis.value = target.offsetWidth < target.scrollWidth;
};
</script>

<template>
  <td
    v-if="isEllipsis"
    v-tooltip.bottom="props.toolTipValue"
    class="body-cell font-normal truncate"
    :class="{ 'body-cell--highlighted': props.isHighlighted }"
    @click="() => emits('onClick')"
    @mouseover="mouseoverTextLabel"
  >
    <slot />
  </td>
  <td
    v-else
    class="body-cell font-normal truncate"
    :class="{ 'body-cell--highlighted': props.isHighlighted }"
    @click="() => emits('onClick')"
    @mouseover="mouseoverTextLabel"
  >
    <slot />
  </td>
</template>

<style lang="scss" scoped>
.body-cell {
  text-align: v-bind(textAlign);
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 16px;
  padding-left: 16px;
  height: 100%;
  background-color: $semanticWhite;
  border-bottom: 1px solid $surfaceSecondary; // 行の区切りになる下線
  // 縦方向に中央揃え
  display: grid;
  align-items: center;

  &--highlighted {
    background-color: $semanticPrimarySubdued;
  }
}
</style>
